import ComplaintRouter from './router';

function App({ pageProps, onPublish, onStepChange, children }) {
  return (
    <ComplaintRouter
      pageProps={pageProps}
      onPublish={onPublish}
      onStepChange={onStepChange}
    >
      {children}
    </ComplaintRouter>
  );
}

export default App;
